import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface RenewalBackState {
  dealId: string | null;
  source: string | null;
  setOrigin: (dealId: string, source: string) => void;
  clearOrigin: () => void;
}

export const useRenewalBackStore = create<RenewalBackState>()(
  devtools(
    (set) => ({
      dealId: null,
      source: null,
      setOrigin: (dealId, source) => set({ dealId, source }),
      clearOrigin: () => set({ dealId: null, source: null }),
    }),
    { name: 'renewal-back-store' },
  ),
);
